/* eslint-disable max-len */
import 'react';

let index = 0;
const OpenChatSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => {
    const timeStamp = index++;

    const getId = (id: string) => {
        return `OpenChatSvgHover${timeStamp}-${id}`;
    };

    return (<svg
        width={32}
        height={32}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <defs>
            <path
                d="M13.077 0c.669 0 .911.07 1.156.2.244.131.436.323.567.567.13.245.2.487.2 1.156v8.654c0 .669-.07.911-.2 1.156-.131.244-.323.436-.567.567-.245.13-.487.2-1.156.2H6.17c-1.062 0-1.674.028-2.257.112a6.803 6.803 0 0 0-1.645.445c-.546.221-1.089.505-2.006 1.04L0 14.25V1.923c0-.669.07-.911.2-1.156C.331.523.523.331.767.2c.245-.13.487-.2 1.156-.2h11.154ZM6.125 4.25h-.75A.375.375 0 0 0 5 4.625v2.75c0 .207.168.375.375.375h.75a.375.375 0 0 0 .375-.375v-2.75a.375.375 0 0 0-.375-.375Zm4.5 0h-.75a.375.375 0 0 0-.375.375v2.75c0 .207.168.375.375.375h.75A.375.375 0 0 0 11 7.375v-2.75a.375.375 0 0 0-.375-.375Z"
                id={getId('a')}
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <circle fill="#F2F6FF" cx={16} cy={16} r={16} />
            <use fill="#4784FF" xlinkHref={`#${getId('a')}`} transform="translate(8.5 9.34)" />
        </g>
    </svg>);
};

export default OpenChatSvg;
